import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const routes = [{
    path: '/',
    name: 'home',
    component: () => import('./view/index'),
    meta: {
      title: 'Home'
    }
  }, {
    path: '/page404',
    name: 'page404',
    component: () => import('./view/page404'),
    meta: {
      title: 'Fastorder -- Notice',
      keepAlive: false,
    }
  }, {
    path: '/user/addressList',
    name: 'userAddressList',
    component: () => import('./view/user/addressList.vue'),
    meta: {
      title: 'Fastorder -- Notice',
      keepAlive: false,
    }
  }, {
    path: '/user/addressDetail',
    name: 'userAddressDetail',
    component: () => import('./view/user/addressDetail.vue'),
    meta: {
      title: 'Fastorder -- Notice',
      keepAlive: false,
    }
  }, {
    path: '/order/driverArrived',
    name: 'orderDriverArrived',
    component: () => import('./view/order/orderDelivery.vue'),
    meta: {
      title: 'My Rider',
      keepAlive: false,
    }
  }, {
    path: '/merchant/index',
    name: 'merchantIndexList',
    component: () => import('./view/merchant/index.vue'),
    meta: {
      title: 'Store List',
      keepAlive: false,
    }
  }, {
    path: '/order/deliveryProcessing',
    name: 'orderDeliveryProcessing',
    component: () => import('./view/order/deliveryOrderProcessing.vue'),
    meta: {
      title: 'Delivery Processing',
      keepAlive: false,
    }
  }, {
    path: '/cart',
    name: 'cart',
    component: () => import('./view/cart/index.vue'),
    meta: {
      title: 'Cart',
      keepAlive: false, //此组件不需要被缓存
    }
  }, {
    path: '/shop/index',
    name: 'shopIndex',
    component: () => import('./view/shop/index.vue'),
    meta: {
      title: 'Merchant',
      keepAlive: false, //此组件不需要被缓存
    }
  }, {
    path: '/googlemap',
    name: 'googlemap',
    component: () => import('./view/index/googleMap.vue'),
    meta: {
      title: 'Google Map Test',
      keepAlive: false, //此组件不需要被缓存
    }
  }, {
    path: '/delivery',
    name: 'deliveryCart',
    component: () => import('./view/cart/delivery.vue'),
    meta: {
      title: 'Delivery',
      keepAlive: false, //此组件不需要被缓存
    }
  }, {
    path: '/delivery/shipment',
    name: 'deliveryShipment',
    component: () => import('./view/cart/shipment.vue'),
    meta: {
      title: 'Choose Ship Type',
      keepAlive: false,
    }
  },
  {
    path: '/takeaway',
    name: 'takeawayCart',
    component: () => import('./view/cart/takeaway.vue'),
    meta: {
      title: 'Takeaway',
      keepAlive: false, //此组件不需要被缓存
    }
  }, {
    path: '/order/history',
    name: 'history',
    component: () => import('./view/order/history'),
    meta: {
      title: 'Order History'
    }
  }, {
    path: '/order',
    name: 'order',
    component: () => import('./view/order'),
    meta: {
      title: 'Order Detail'
    }
  },
]

// add route path
routes.forEach(route => {
  route.path = route.path || '/' + (route.name || '');
})

const router = new Router({
  routes
})

router.beforeEach((to, from, next) => {
  const title = to.meta && to.meta.title;
  if (title) {
    document.title = title;
  }
  next();
})

export {
  router
}